"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FaceUnhappySVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FaceUnhappySVG = function FaceUnhappySVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm5.6,16-.37,0a22.73,22.73,0,0,0-5.39,1.09h0l-.51.18a22.54,22.54,0,0,0-2.26,1c-.6.32-1.17.65-1.69,1L11,21.6h0l-.26.18a1,1,0,0,0,1.13,1.65c.1-.08.31-.21.6-.39h0l.37-.23c.37-.22.77-.45,1.19-.67a18.57,18.57,0,0,1,2.43-1.08h0l.55-.18a21.39,21.39,0,0,1,4.41-.82h0l.31,0a1,1,0,1,0-.1-2ZM12,11a2,2,0,1,0,2,2A2,2,0,0,0,12,11Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,20,11Z"
  }));
};
exports.FaceUnhappySVG = FaceUnhappySVG;
FaceUnhappySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FaceUnhappySVG);
exports.default = _default;